// extracted by mini-css-extract-plugin
module.exports = {"expandableSummary":"styles-module__expandableSummary___38s3f"};